module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '9uw9eyl9',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
